import type { SharedConfiguration } from '@autobid/strapi-integration/rest/components'

export function isComponentVisible(authenticated: boolean, visability?: SharedConfiguration['visability'] | null) {
  if (!visability)
    return true

  return (
    (authenticated && visability === 'authenticated')
    || (!authenticated && visability === 'unauthenticated')
  )
}
